import { Link, Text } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent } from 'react'
import { HelpButton } from '../HelpButton'
import { useRouter } from 'next/router'

import styles from './style.module.scss'
import clsx from 'clsx'
import { Country, SupportedLocale } from '@afterpay/types'
import { useConsumerCountry } from '../../state'

const I18N_NAMESPACE = ['common']

interface FooterProps {
  isHelpDisplayed?: boolean
  center?: boolean
}

export const Footer: FunctionComponent<FooterProps> = ({ isHelpDisplayed = true, center = false }) => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const router = useRouter()
  const isUK = router.locale === ('en-GB' as SupportedLocale)
  const isAUConsumer = useConsumerCountry() === Country.AU
  const classNames = clsx(styles.footer, center && styles.center)

  return (
    <>
      <div className={classNames}>
        <div className='flex flex-row items-center justify-center space-x-2'>
          <Text size='XS'>{t('common:footerCopyright', { year: new Date().getFullYear() })}</Text>
          <Link size='XS' kind='Underline' href={t('common:urls:termsOfServiceUrl')} target='_blank' testNameSpace='footer-terms'>
            {t('common:footerTerms')}
          </Link>
          <Link size='XS' kind='Underline' href={t('common:urls:privacyPolicyUrl')} target='_blank' testNameSpace='footer-privacy-policy'>
            {t('common:footerPrivacy')}
          </Link>
          {isUK && (
            <Link size='XS' kind='Underline' href={t('common:urls:cookiesUrl')} target='_blank' testNameSpace='footer-cookies'>
              {t('common:footerCookies')}
            </Link>
          )}
        </div>
        {isAUConsumer && (
          <div className='text-center'>
            <Text size='XS'>{t('common:creditLicence', { defaultValue: '' })}</Text>
          </div>
        )}
        {isHelpDisplayed && <HelpButton />}
      </div>
    </>
  )
}
